<template>
  <div id="login">
    <el-container :style="{background:`url(${bgUrl})`,}"> 
      <el-main class="mainRow">
        <el-row>
          <el-col style="margin-top:20vh">
            <img :src="iconUrl" width="20%"/>>
          </el-col>
          <el-col style="margin-top:2em;">
            <el-card style="height:20vh;background-color: transparent;border:none;width:20vw;margin:0 auto;">
                <el-input placeholder="请输入用户名" prefix-icon="el-icon-user-solid" v-model="userName"></el-input>
                <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="pwdStr" show-password style="margin-top:1em;"></el-input>
                <el-button type="success" :style="{width:'100%',marginTop:'1em'}" @click="gotoMain()">登陆</el-button>
            </el-card>
            <router-view></router-view>
          </el-col>
        </el-row>
      </el-main>
      
    
    </el-container>
    
  </div>
</template>

<style>
.el-dialog{
  background-color: transparent !important;  
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.el-input__inner{
  text-align: center;
}

.el-dialog--center .el-dialog__body{
  text-align:center !important;
  border: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  background-color: transparent;
}

html,body{
        /*设置内部填充为0，几个布局元素之间没有间距*/
        padding: 0px;
         /*外部间距也是如此设置*/
        margin: 0px;
        /*统一设置高度为100%*/
        height: 100%;
    }

.el-container{
  height: 100%;
  width: 100%;
  background-size: 100% 100% !important;
  
}    

#login {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
}
</style>
<script>
//import router from './router'

export default {
  data(){
    return {
      centerDialogVisible:true,
      shopShow:new Array(),
      timer:"",
      indexNum:0,
      mohuStyle:{
        'filter': 'blur(10px)'
      },
      bgUrl:require("../assets/1.jpg"),
      iconUrl:require("../assets/logo.png"),
      userName:"",
      pwdStr:"",
    }
  },
  mounted:function(){
    //this.centerDialogVisible = true;
    //this.timer = setInterval(this.addShop, 300);
  },
  methods:{
    gotoMain(){
      this.$router.push('/cjIndex');
      //router.push('/cjIndex');
      if(this.userName == "cs" && this.pwdStr == "123456"){
        
      }
    },
    addShop(){
      var o = {qu:"长宁区",name:"hsopname"+this.indexNum,address:"addresssssss"+this.indexNum};
      this.indexNum +=1;
      this.shopShow.push(o);
      //let container = this.$el.querySelector(".el-card");
      //container.scrollTop = container.scrollHeight;
    },
    showalert(){
      console.log('123');
      this.centerDialogVisible = false;

      this.mohuStyle={
        'filter': 'none'
      };
    }
  }
}
</script>